import { Outlet } from 'react-router';
import { BrandedEmailsSettingsNavBar } from '@BrandedEmails/components/BrandedEmailsSettings/BrandedEmailsSettingsNavBar';
import { SettingsPage } from '@common/components/SettingsPage/SettingsPage';

export function BrandedEmailsSettingsLayout(): JSX.Element {
    return (
        <SettingsPage>
            <BrandedEmailsSettingsNavBar />
            <Outlet />
        </SettingsPage>
    );
}
